import { FC } from 'react';
import { faCheck } from '~/assets';
import {
  Description,
  IconComponent,
  Title,
  Wrapper,
  WrapperRounded,
} from './styles';

type Props = {
  title: string;
  description: string;
  className?: string;
};

const SuccessData: FC<Props> = ({ title, description, className }) => (
  <Wrapper className={className}>
    <WrapperRounded>
      <IconComponent icon={faCheck} />
    </WrapperRounded>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Wrapper>
);

export default SuccessData;
